/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../buttons/Button';

import acadienouvelle from '../../../img/medias/acadienouvelle.png';
import coopinfo from '../../../img/medias/coopinfo.png';
import lactualite from '../../../img/medias/lactualite.png';
import lesaffaires from '../../../img/medias/lesaffaires.png';
import styles from '../../../styles/partials/subscribe.module.css';

const propTypes = {
    invert: PropTypes.bool,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    logoClassName: PropTypes.string,
};

const defaultProps = {
    invert: false,
    className: null,
    buttonClassName: null,
    logoClassName: null,
};

function Subscribe({ invert, className, buttonClassName, logoClassName }) {
    return (
        <div
            className={classNames([
                styles.container,
                { [styles.invert]: invert, [className]: className !== null },
            ])}
        >
            <Button
                className={classNames([
                    styles.button,
                    { [buttonClassName]: buttonClassName !== null },
                ])}
                href="https://www.lesoleil.com/infolettres/inscriptions/?utm_source=web&utm_medium=web&utm_campaign=campagne-conjointe-sensibilisation&utm_id=sensibilisation"
                external
            >
                <div
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                >
                    <img className={styles.img} src={coopinfo} alt="coopinfo" />
                </div>
            </Button>
            <Button
                className={classNames([
                    styles.button,
                    { [buttonClassName]: buttonClassName !== null },
                ])}
                href="https://www.ledevoir.com/infolettres?utm_source=site_web&utm_medium=display&utm_campaign=faussesnouvelles"
                external
            >
                <div
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                >
                    <svg
                        className={styles.svg}
                        width="101"
                        height="20"
                        viewBox="0 0 101 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M90.9959 9.5966V0.9735C90.9959 0.806643 91.0502 0.695276 91.1586 0.695276H92.2967C92.9292 0.695276 93.3629 0.834388 93.6881 1.19608C94.3205 1.89145 94.5373 3.44916 94.5373 5.17376C94.5373 6.87062 94.3567 8.17796 93.8328 8.9289C93.5075 9.42959 92.9656 9.59652 92.3511 9.59652L90.9959 9.5966ZM97.0129 19.9443C99.1629 19.9443 99.9942 18.4422 100.03 15.5215H99.8136C99.8136 17.3853 99.4522 18.4422 98.8199 18.4422C98.3679 18.4422 98.1332 18.1083 98.0067 17.552C97.8621 16.7733 97.7536 15.5215 97.6634 14.3532C97.4466 11.2378 95.7843 10.2642 93.7062 9.90257V9.84692C96.2901 9.5687 97.8982 8.01111 97.8982 5.11819C97.8982 2.0306 96.4887 0.305878 93.1822 0.305878H85.8282V0.584102L87.3458 0.611964C87.4904 0.611964 87.5265 0.695392 87.5265 0.862288V19.0264C87.5265 19.2212 87.4904 19.2768 87.3459 19.2768L85.8282 19.3046V19.5827H92.6581V19.3045L91.1765 19.2767C91.0319 19.2767 90.9959 19.2211 90.9959 18.8873V9.98604L92.4235 10.0139C93.363 10.0139 93.9773 10.4868 94.0496 12.1279C94.0858 13.1294 94.122 14.4646 94.1761 15.2712C94.3206 18.5256 95.3144 19.9443 97.0129 19.9443ZM78.3837 19.5827H85.2501V19.3045L83.7323 19.2767C83.5876 19.2767 83.5336 19.2211 83.5336 19.0264V0.862172C83.5336 0.667492 83.5876 0.611847 83.7323 0.611847L85.2501 0.583947V0.305839H78.3837V0.584064L79.9017 0.611925C80.0462 0.611925 80.0824 0.66757 80.0824 0.862249V19.0264C80.0824 19.2211 80.0462 19.2767 79.9017 19.2767L78.3837 19.3045V19.5827ZM71.6802 19.9999C75.5651 19.9999 78.1671 15.6328 78.1671 10.0138C78.1671 4.3671 75.5651 -9.15527e-05 71.6802 -9.15527e-05C67.7955 -9.15527e-05 65.1754 4.3671 65.1754 10.0138C65.1755 15.6329 67.7955 19.9999 71.6802 19.9999ZM71.6802 19.6662C71.2649 19.6662 70.9214 19.6105 70.5058 19.221C69.5481 18.3032 69.006 15.6606 69.006 10.0138C69.006 4.3392 69.5481 1.69661 70.5058 0.778743C70.9214 0.361445 71.2649 0.3058 71.6802 0.3058C72.0778 0.3058 72.4393 0.361445 72.8366 0.778704C73.7944 1.69657 74.3545 4.33916 74.3545 10.0138C74.3545 15.6605 73.7944 18.3032 72.8367 19.221C72.4393 19.6104 72.0778 19.6662 71.6802 19.6662ZM59.303 19.6662H60.5136L64.5431 2.80936C64.9225 1.22379 65.2297 0.639708 65.8982 0.611925L66.5669 0.584025V0.305839H62.8266V0.584064L63.676 0.611925C64.5972 0.639708 64.507 1.80798 64.2179 3.00415L61.5798 14.075H61.5255L58.8152 1.83572C58.6346 1.00128 58.6167 0.63967 59.1044 0.611886L60.3511 0.583986V0.305839H53.6655V0.584064L54.4245 0.611925C54.9666 0.639708 55.1111 1.05697 55.3279 1.97484L59.303 19.6662ZM41.1979 19.5827H53.4306V11.6272H53.2681C52.8161 13.6022 52.2199 15.577 51.4249 16.9957C50.5938 18.5535 49.6904 19.2211 48.2447 19.2211H46.5462C46.4018 19.2211 46.3656 19.1376 46.3656 18.9707V10.0138H46.9618C47.7206 10.0138 48.3531 10.2086 48.787 10.8761C49.3469 11.655 49.6904 13.0736 49.7264 14.4645H49.9433V5.2294H49.7264C49.6905 6.62026 49.2566 8.0666 48.7687 8.8178C48.3532 9.51317 47.739 9.68011 46.9618 9.68011H46.3657V0.917856C46.3657 0.751037 46.4019 0.667531 46.5283 0.667531H48.1365C49.2929 0.667531 50.1783 1.19608 50.7924 2.00266C51.6238 3.05964 52.2742 4.92344 52.7439 7.48248H52.9429V0.3058H41.1979V0.584025L42.7156 0.611886C42.8602 0.611886 42.8964 0.695276 42.8964 0.862211V19.0264C42.8964 19.1933 42.8602 19.2767 42.7156 19.2767L41.1979 19.3045V19.5827ZM32.561 19.2211C32.4166 19.2211 32.3804 19.1377 32.3804 18.9708V0.890033C32.3804 0.723137 32.4166 0.639709 32.5429 0.639709H33.9343C34.5847 0.639709 35.1268 0.750998 35.5605 1.08475C36.6807 1.94705 37.1685 4.75646 37.1685 9.986C37.1685 15.0764 36.5362 17.7746 35.5785 18.7203C35.1269 19.1376 34.5848 19.221 34.0245 19.221L32.561 19.2211ZM27.2306 19.5827H34.4581C38.0359 19.5827 40.9812 16.1056 40.9812 9.95825C40.9812 3.86638 38.09 0.305839 34.3859 0.305839H27.2305V0.584064L28.7484 0.611925C28.8928 0.611925 28.9291 0.695315 28.9291 0.862249V19.0264C28.9291 19.1933 28.8929 19.2767 28.7484 19.2767L27.2306 19.3045V19.5827Z"
                            fill="white"
                        />
                        <path
                            d="M13.3754 19.6H25.6305V11.6763H25.4677C25.0151 13.6434 24.4176 15.6104 23.6211 17.0233C22.7886 18.575 21.8834 19.2398 20.4353 19.2398H18.7337C18.5888 19.2398 18.5526 19.1567 18.5526 18.9905V10.0694H19.1497C19.9102 10.0694 20.5439 10.2635 20.9783 10.9283C21.5393 11.7041 21.8834 13.117 21.9197 14.5024H22.1369V5.30413H21.9197C21.8834 6.68944 21.4489 8.12997 20.96 8.87815C20.5438 9.57077 19.9283 9.73701 19.1497 9.73701H18.5525V1.00986C18.5525 0.843664 18.5886 0.760507 18.7152 0.760507H20.3266C21.485 0.760507 22.372 1.28696 22.9875 2.09029C23.8201 3.14312 24.4717 4.9994 24.9424 7.54821H25.1417V0.40021H13.3754V0.677272L14.896 0.705056C15.0407 0.705056 15.077 0.788135 15.077 0.954411V19.0459C15.077 19.2121 15.0407 19.2953 14.896 19.2953L13.3754 19.3229V19.6ZM0.830566 19.6H12.6333V11.039H12.4341C11.9636 13.006 11.4024 15.0286 10.6238 16.5523C9.75514 18.2424 9.03102 19.2675 7.78199 19.2675H6.18883C6.04398 19.2675 6.00787 19.1567 6.00787 18.9904L5.98981 0.954256C5.98981 0.760313 6.04398 0.704901 6.18883 0.704901L7.70949 0.677117V0.400055H0.830566V0.677117L2.35111 0.704901C2.49592 0.704901 2.53215 0.760313 2.53215 0.954218V19.0457C2.53215 19.212 2.49592 19.3228 2.35115 19.3228H0.830566V19.6Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </Button>
            <Button
                className={classNames([
                    styles.button,
                    { [buttonClassName]: buttonClassName !== null },
                ])}
                href="http://eepurl.com/g3P9an"
                external
            >
                <div
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                >
                    <img className={styles.img} src={acadienouvelle} alt="acadienouvelle" />
                </div>
            </Button>
            <Button
                className={classNames([
                    styles.button,
                    { [buttonClassName]: buttonClassName !== null },
                ])}
                href="https://lactualite.com/infolettre?utm_source=fausses-nouvelles&utm_medium=referral&utm_campaign=2023-2024"
                external
            >
                <div
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                >
                    <img className={styles.img} src={lactualite} alt="lactualite" />
                </div>
            </Button>
            <Button
                className={classNames([
                    styles.button,
                    { [buttonClassName]: buttonClassName !== null },
                ])}
                href="https://content.lesaffaires.com/LAF/pelcro-paywall-test/landing_page_regulier.html?%20utm_campaign=ABNT_noel2023&utm_content=offre_unique"
                external
            >
                <div
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                >
                    <img className={styles.img} src={lesaffaires} alt="lesaffaires" />
                </div>
            </Button>
            <Button
                className={classNames([
                    styles.button,
                    { [buttonClassName]: buttonClassName !== null },
                ])}
                href="https://urbania.ca/abonnement?utm_source=landing_page&utm_medium=subscribe_cta&utm_campaign=stunt_c18"
                external
            >
                <div
                    className={classNames([
                        styles.logo,
                        { [logoClassName]: logoClassName !== null },
                    ])}
                >
                    <svg
                        className={styles.svg}
                        xmlns="http://www.w3.org/2000/svg"
                        width="73.7px"
                        height="25.5px"
                        viewBox="0 0 73.7 25.5"
                    >
                        <path
                            fill="currentColor"
                            d="M27 12.2c0-.1 1-.3 1.7-1.2.5-.7.7-1.3.7-2.5v-3c0-1.5-.4-2.9-1.4-4C26.9.5 25.2 0 23.7 0h-3.6c-.4 0-.7 0-.9.2-.2.2-.2.5-.2 1v23c0 .8 0 .8.2 1.1.1.2.6.1 1.1.2h3.5c1.4 0 3.1-.4 4.2-1.6 1.2-1.3 1.5-2.5 1.5-3.9v-4.2c0-1-.1-1.6-.6-2.2-.7-1.2-1.9-1.3-1.9-1.4m-4.1-7.7c0-.2 0-.4.1-.5s.4-.1.8-.1c.7 0 .9.1 1.2.4.5.5.5 1.2.5 2v2.5c0 .4 0 .9-.5 1.4-.4.4-.9.5-1.3.5-.3 0-.5 0-.7-.1-.2-.1-.2-.4-.2-.7V4.5zm2.7 15c0 .7 0 1.1-.5 1.6-.4.4-1 .5-1.3.5h-.7c-.3 0-.3-.4-.3-.8v-6c0-.7.1-.7 1.3-.7 1.1 0 1.5.9 1.5 2.3v3.1zM14.7 12.3c0-.1 1.1-.3 1.8-1.3.5-.7.6-1.3.6-2.4V5.5c0-1.5-.4-3-1.5-4S12.9 0 11.3 0H7.7c-.5 0-.7 0-.9.2-.1.2-.2.6-.2 1v18.3c0 1-.2 2-1.4 2s-1.4-1.1-1.4-2V.6C3.9.1 3.5 0 2 0 .2 0 0 0 0 .6v19.7c0 2.6 2 5 5.3 5 3.4 0 5.3-2.1 5.3-5.1v-6c.1-.2.4-.2 1.4-.2.9 0 1.3 1 1.3 2.3v8.3c0 .7.1.6 1.9.6 1.7 0 2 0 2-.6v-9.1c0-1-.2-1.6-.7-2.3-.7-.7-1.8-.8-1.8-.9m-1.5-3.6c0 .4 0 .9-.5 1.4-.4.4-1 .5-1.3.5-.3 0-.5 0-.7-.1-.2-.1-.2-.4-.2-.7V4.5c0-.2 0-.3.1-.5s.4-.2.7-.2c.8 0 1.1.1 1.3.4.5.5.5 1.2.5 2v2.5zM39.2 25.5c-1.1 0-1.7.1-1.8-.4-.3-2-.4-3.4-.7-5.4 0-.4-.5-.3-1.1-.3-.7 0-1.1-.1-1.1.3-.2 2-.4 3.4-.5 5.5 0 .4-.8.4-2 .4-.5 0-1.8 0-1.8-.3 1.3-9.5 2.3-15.8 3.5-24.6.1-.7 1.1-.7 1.9-.7.9 0 1.9 0 2 .7 1.4 9.3 2.2 15 3.6 24.4.1.4-1 .4-2 .4M35.9 9.3c0-.2-.1-1-.3-1-.2 0-.3.9-.2 1.1-.2 2.8-.3 4.6-.5 7 0 .3.2.3.7.3.5 0 .8.1.8-.3-.2-2.7-.3-4.3-.5-7.1M52.4 25.5c-.9 0-1.3-.1-1.6-1-1.2-4.2-1.6-6.1-2.9-10.7-.2-.8-.5-2.1-.8-2.1-.3 0-.3.8-.3 1.2v11.9c0 .6-.1.7-2 .7-1.8 0-1.8-.1-1.8-.6V.5c.1-.5.1-.5 1.7-.5 1.6 0 1.8.1 2 1.2.8 3 1.9 6.9 2.9 10.7.1.4.2.9.4.9.3 0 .3-.7.3-1.1V.7c0-.6.1-.7 1.9-.7 1.9 0 1.9 0 1.9.6v23.7c.1 1 .2 1.2-1.7 1.2M58.8 25.4c-1.8 0-1.9 0-1.9-.5V.7c0-.5.1-.6 1.9-.6 1.9 0 2 0 2 .6v24.1c.1.6 0 .6-2 .6M71.7 25.5c-1.1 0-1.7.1-1.8-.4-.3-2-.4-3.4-.7-5.4 0-.4-.5-.3-1.1-.3-.7 0-1.1-.1-1.1.3-.2 2-.4 3.4-.5 5.5 0 .4-.8.4-2 .4-.5 0-1.8 0-1.8-.3C64 15.8 65 9.5 66.2.7c.1-.7 1.1-.7 1.9-.7.9 0 1.9 0 2 .7 1.4 9.3 2.2 15 3.6 24.4.1.4-1 .4-2 .4M68.4 9.3c0-.2-.1-1-.3-1-.2 0-.3.9-.2 1.1-.2 2.8-.3 4.6-.5 7 0 .3.2.3.7.3.5 0 .8.1.8-.3-.2-2.7-.3-4.3-.5-7.1"
                        />
                    </svg>
                </div>
            </Button>
        </div>
    );
}

Subscribe.propTypes = propTypes;
Subscribe.defaultProps = defaultProps;

export default Subscribe;
